/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client, RequestContext } from "../client";
import type { DeploymentTargetResource, ResourceCollection } from "../resources";
import type { MachinePolicyResource, WorkerMachineResource } from "../resources/index";
import { BasicRepository } from "./basicRepository";
export class MachinePolicyRepository extends BasicRepository<MachinePolicyResource, any> {
    constructor(client: Client, requestContext: RequestContext) {
        super("MachinePolicies", client, requestContext);
    }
    getTemplate(): Promise<MachinePolicyResource> {
        return this.client.get(this.requestContext, this.client.getLink("MachinePolicyTemplate"));
    }
    getMachines(machinePolicy: MachinePolicyResource): Promise<ResourceCollection<DeploymentTargetResource>> {
        return this.client.get(this.requestContext, machinePolicy.Links["Machines"]);
    }
    getWorkers(machinePolicy: MachinePolicyResource): Promise<ResourceCollection<WorkerMachineResource>> {
        return this.client.get(this.requestContext, machinePolicy.Links["Workers"]);
    }
}
